export const LANGUAGE_STORAGE_KEY = "auditguard.language";

export const DEFAULT_LANGUAGE = "ar";
export const FALLBACK_LANGUAGE = "en";

export const SUPPORTED_LANGUAGES = {
  en: {
    code: "en",
    label: "English",
    dir: "ltr",
  },
  ar: {
    code: "ar",
    label: "العربية",
    dir: "rtl",
  },
};

export const INITIAL_NAMESPACES = ["common", "sidebar"];

export const I18N_NAMESPACES = [
  "common",
  "sidebar",
  "pages",
  "auth",
  "dashboard",
  "invoice",
  "clients",
  "vendors",
  "products",
  "payments",
  "auditLogs",
  "settings",
  "onboarding",
];

export const isSupportedLanguage = (language) =>
  Boolean(SUPPORTED_LANGUAGES[language]);

export const normalizeLanguage = (language) => {
  if (!language || typeof language !== "string") {
    return DEFAULT_LANGUAGE;
  }

  const languageCode = language.toLowerCase().split("-")[0];
  return isSupportedLanguage(languageCode) ? languageCode : DEFAULT_LANGUAGE;
};

export const getLanguageDirection = (language) =>
  SUPPORTED_LANGUAGES[normalizeLanguage(language)]?.dir || "ltr";

export const getInitialLanguage = () => {
  try {
    const savedLanguage = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
    return isSupportedLanguage(savedLanguage) ? savedLanguage : DEFAULT_LANGUAGE;
  } catch (error) {
    return DEFAULT_LANGUAGE;
  }
};

export const persistLanguage = (language) => {
  try {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, normalizeLanguage(language));
  } catch (error) {
    // Storage can be unavailable in private browsing or restricted embeds.
  }
};

export const applyDocumentLanguage = (language) => {
  if (typeof document === "undefined") {
    return;
  }

  const normalizedLanguage = normalizeLanguage(language);
  document.documentElement.lang = normalizedLanguage;
  document.documentElement.dir = getLanguageDirection(normalizedLanguage);
};
